/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const TermsIcon = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="32" height="32">
    <defs>
      <path
        id="terms_a"
        d="M12.262 2.25H9.45C9.45 1.009 8.441 0 7.2 0S4.95 1.009 4.95 2.25H2.137C1.206 2.25.45 3.006.45 3.937v12.375c0 .932.756 1.688 1.687 1.688h10.125c.932 0 1.688-.756 1.688-1.688V3.938c0-.931-.756-1.687-1.688-1.687zM3.825 14.906a.842.842 0 01-.844-.844c0-.467.376-.843.844-.843.468 0 .844.376.844.844a.841.841 0 01-.844.843zm0-3.375a.842.842 0 01-.844-.844c0-.467.376-.843.844-.843.468 0 .844.376.844.844a.841.841 0 01-.844.843zm0-3.375a.842.842 0 01-.844-.844c0-.467.376-.843.844-.843.468 0 .844.376.844.843a.842.842 0 01-.844.844zM7.2 1.406c.468 0 .844.376.844.844a.842.842 0 01-.844.844.842.842 0 01-.844-.844c0-.468.376-.844.844-.844zm4.5 12.938a.283.283 0 01-.281.281H6.356a.283.283 0 01-.281-.281v-.563c0-.154.127-.281.281-.281h5.063c.154 0 .281.127.281.281v.563zm0-3.375a.283.283 0 01-.281.281H6.356a.283.283 0 01-.281-.281v-.563c0-.154.127-.281.281-.281h5.063c.154 0 .281.127.281.281v.563zm0-3.375a.283.283 0 01-.281.281H6.356a.283.283 0 01-.281-.281V7.03c0-.154.127-.281.281-.281h5.063c.154 0 .281.127.281.281v.563z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" />
      <g transform="translate(9 7)">
        <mask id="terms_b" fill="#fff">
          <use xlinkHref="#terms_a" />
        </mask>
        <g fill="#9A8B88" mask="url(#terms_b)">
          <path d="M-3.6-1.8H18v21.6H-3.6z" />
        </g>
      </g>
    </g>
  </svg>
)
